export default __webpack_public_path__ + "static/media/176.fafae5de.png";